module.exports = __webpack_public_path__ + "static/media/avatar.ca9794cb.png";